import { NAVIGATION_TOF_IS_TOGGLED } from './types';

export const triggerNavigationTOFIsToggled = wasOpen => ({
  type: NAVIGATION_TOF_IS_TOGGLED,
  wasOpen,
});
